import React from 'react';
import Footer from '~/components/footer';
import { withRouter } from 'react-router-dom';
import FileViewer from 'react-file-viewer';

class PolicyExchange extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            message_load: 'loading',
            loaded: false
        }
    }
    
    render() {
        require('./scss/policy-exchange.scss');
        return(
            <>
                <div className='container-page container-fluid show' style={{marginTop: '-15px'}}>
                    <main id="panel">
                        <FileViewer
                            fileType={'docx'}
                            filePath={process.env.PUBLIC_URL + '/terms/policy-exchange.docx'}/>
                    </main>
                </div>
                <Footer />
            </>
        );
    }
}

export default withRouter(PolicyExchange);